export enum PurchaseOrderStatusEnum {
  PendingReceipt = 'PendingReceipt',
  PartiallyReceived = 'PartiallyReceived',
  PendingBilling = 'PendingBilling',
  FullyBilled = 'FullyBilled',
  Closed = 'Closed',
}

export enum DocumentStatusEnum {
  Draft = 0,
  Open = 1,
  Closed = 2,
  Cancelled = 3,
}

export interface PurchaseOrderDto {
  id: number;
  netSuitePOId: string;
  poNumber: string;
  vendorName: string;
  vendorId?: string;
  poDate: string;
  poStatus: string;
  netSuiteStatus: string;
  documentStatus: DocumentStatusEnum;
  forAdjustment: boolean;
  syncedAt: string;
  termsAndConditions?: string;
  deliveryType: number;
  stickyNotes: string[];
  lines: PurchaseOrderLineDto[];
  serverTimestamp: string;
  /** Receiving docs already open against this PO whose IR hasn't posted (drafts + submitted-unposted). 0 = none. */
  inProgressReceivingCount: number;
}

export interface PurchaseOrderLineDto {
  id: number;
  lineNumber: number;
  netSuiteLineId: string;
  netsuiteItemId: number;
  itemCode: string;
  itemDescription: string;
  poQuantity: number;
  quantityReceived: number;
  remainingQuantity: number;
  unitOfMeasure: string;
  itemType: number;
  isServiceItem: boolean;
  quantityForPutAway: number;
}

export interface PoSearchResultDto {
  id: number;
  netSuitePOId: string;
  poNumber: string;
  vendorName: string;
  poStatus: string;
}

export interface PurchaseOrderSyncResultDto {
  success: boolean;
  totalFetched: number;
  newRecordsCreated: number;
  skippedIneligible: number;
  updatedExisting: number;
  statusChanged: number;
  reopened: number;
  flagged: number;
  failed: number;
  errors: string[];
  syncedAt: string;
}
